import { regionData } from 'element-china-area-data';
// 年级
export const gradeList = [
  {
    value: 1,
    label: '一年级'
  },
  {
    value: 2,
    label: '二年级'
  },
  {
    value: 3,
    label: '三年级'
  },
  {
    value: 4,
    label: '四年级'
  },
  {
    value: 5,
    label: '五年级'
  },
  {
    value: 6,
    label: '六年级'
  },
  {
    value: 7,
    label: '初一'
  },
  {
    value: 8,
    label: '初二'
  },
  {
    value: 9,
    label: '初三'
  },
  {
    value: 10,
    label: '高一'
  },
  {
    value: 11,
    label: '高二'
  },
  {
    value: 12,
    label: '高三'
  },
  {
    value: 13,
    label: '小班'
  },
  {
    value: 14,
    label: '中班'
  },
  {
    value: 15,
    label: '大班'
  }
];

// 年级
export const gradeStrList = [
  '',
  '一年级',
  '二年级',
  '三年级',
  '四年级',
  '五年级',
  '六年级',
  '初一',
  '初二',
  '初三',
  '高一',
  '高二',
  '高三',
  '幼儿园小班',
  '幼儿园中班',
  '幼儿园大班'
];
export const gradeStrListshort = [
  '',
  '一年级',
  '二年级',
  '三年级',
  '四年级',
  '五年级',
  '六年级',
  '初一',
  '初二',
  '初三',
  '高一',
  '高二',
  '高三',
  '小班',
  '中班',
  '大班'
];

// // 周列表
// export const weekList = [
//   {
//     value: 0,
//     label: "周一"
//   },
//   {
//     value: 1,
//     label: "周二"
//   },
//   {
//     value: 2,
//     label: "周三"
//   },
//   {
//     value: 3,
//     label: "周四"
//   },
//   {
//     value: 4,
//     label: "周五"
//   },
//   {
//     value: 5,
//     label: "周六"
//   },
//   {
//     value: 6,
//     label: "周日"
//   }
// ];
// 周列表
export const weekList = [
  {
    value: 1,
    label: '周一'
  },
  {
    value: 2,
    label: '周二'
  },
  {
    value: 3,
    label: '周三'
  },
  {
    value: 4,
    label: '周四'
  },
  {
    value: 5,
    label: '周五'
  },
  {
    value: 6,
    label: '周六'
  },
  {
    value: 7,
    label: '周日'
  }
];

// 支付方式
export const payTypeList = [
  {
    value: 1,
    label: '微信'
  },
  {
    value: 2,
    label: '现金'
  },
  {
    value: 3,
    label: 'POS机'
  },
  {
    value: 4,
    label: '银行汇款转账'
  },
  {
    value: 5,
    label: '支付宝转账'
  },
  {
    value: 6,
    label: '其他'
  }
];

export const payTypeStrList = [
  '-',
  '微信',
  '现金',
  'POS机',
  '银行汇款转账',
  '支付宝转账',
  '其他'
];

/**
 * 单位类型
 */
export const orgTyleList = [
  {
    value: 1,
    label: '学校'
  },
  {
    value: 2,
    label: '教育局'
  },
  {
    value: 3,
    label: '教育集团'
  },
  {
    value: 4,
    label: '教培机构'
  },
  {
    value: 5,
    label: '技术服务商'
  },
  {
    value: 6,
    label: '宏图'
  }
];

/**
 * 完成状态
 */
export const completeStatusList = [
  {
    value: 0,
    label: '待完善',
    tagColor: 'red'
  },
  {
    value: 1,
    label: '信息完善',
    tagColor: 'blue'
  }
];

/**
 * 合作状态
 */
export const cooperationList = [
  {
    value: 1,
    label: '正式合作',
    color: '#53b467'
  },
  {
    value: 2,
    label: '洽谈中',
    color: '#f3a000'
  },
  {
    value: 3,
    label: '已终止合作',
    color: '#a4a4a5'
  }
];

/**
 * 账号类别
 */
export const orgKindList = [
  {
    value: 1,
    label: '正式号'
  },
  {
    value: 2,
    label: '测试号'
  },
  {
    value: 3,
    label: '体验号'
  }
];

/**
 * 单位级别
 */
export const orgRankList = [
  {
    value: 1,
    label: '区属学校'
  },
  {
    value: 2,
    label: '市属学校'
  },
  {
    value: 3,
    label: '省属学校'
  }
];

/**
 * 教育局 单位级别
 */
export const orgEduRankList = [
  {
    value: 1,
    label: '区教育局'
  },
  {
    value: 2,
    label: '市教育局'
  },
  {
    value: 3,
    label: '省教育厅'
  }
];

/**
 * 办学类型
 */
export const schModeList = [
  {
    value: 1,
    label: '公办'
  },
  {
    value: 2,
    label: '民办'
  },
  {
    value: 3,
    label: '合作办学'
  }
];

/**
 * 所在地属性
 */
export const slocalPropertyList = [
  {
    value: 1,
    label: '城市'
  },
  {
    value: 2,
    label: '乡镇'
  }
];

/**
 * 人数规模
 */
export const memScopeList = [
  {
    value: 1,
    label: '小于50人'
  },
  {
    value: 2,
    label: '50-99人'
  },
  {
    value: 3,
    label: '100-499人'
  },
  {
    value: 4,
    label: '500-999人'
  },
  {
    value: 5,
    label: '1000-4999人'
  },
  {
    value: 6,
    label: '5000-9999人'
  },
  {
    value: 7,
    label: '10000人以上'
  }
];

/**
 * 合作性质
 */
export const coopTypeList = [
  {
    value: 1,
    label: '自营'
  },
  {
    value: 2,
    label: '非自营'
  }
];

/**
 * 区域信息
 */
export const fieldList = [
  {
    value: 1,
    label: '建筑信息'
  },
  {
    value: 2,
    label: '场室信息'
  }
];

/**
 * 区域信息
 */
export const reviewStateList = [
  {
    value: 0,
    label: '未审批'
  },
  {
    value: 1,
    label: '通过'
  },
  {
    value: 2,
    label: '未通过'
  }
];

// 办学类型
export const schModeTypeList = ['', '公办', '民办', '合作办学'];
// 学段
export const school = {
  1: '幼儿园',
  2: '小学',
  4: '初中',
  8: '高中'
};

export function changeDictionaries(paramsArr, key = 'label') {
  const arr = [];
  paramsArr.forEach((el) => {
    arr[el.value] = el[key];
  });
  return arr;
}

// 基础信息
export const baseInfoFormat = {
  title: '基础信息',
  list: [
    {
      key: 'name',
      label: '单位全称',
      value: ''
    },
    {
      key: 'shortName',
      label: '单位简称',
      value: ''
    },
    {
      key: 'organizeCode',
      label: '组织机构代码',
      value: ''
    },
    {
      key: 'orgLevel',
      label: '单位级别',
      value: ''
    },
    {
      key: 'areaName',
      label: '所属行政区',
      value: ''
    },
    {
      key: 'parentOrgName',
      label: '上级单位',
      value: ''
    },
    {
      key: 'orgAddr',
      label: '详细地址',
      value: ''
    },
    {
      key: 'contactName',
      label: '单位联系人姓名',
      value: ''
    },
    {
      key: 'contactPhoneNo',
      label: '联系人手机号',
      value: ''
    }
  ]
};

// 合作信息
export const coInfoFormat = {
  title: '合作信息',
  list: [
    {
      key: 'orgKind',
      label: '单位类别',
      value: ''
    },
    {
      key: 'coSts',
      label: '合作状态',
      value: ''
    }
  ]
};

// 详细信息
export const dtlInfoFormat = {
  title: '详细信息',
  list: [
    {
      key: 'memScopeType',
      label: '企业人数',
      value: ''
    },
    {
      key: 'orgUrl',
      label: '企业官网',
      value: ''
    },
    {
      key: 'orgDesc',
      label: '企业简介',
      value: ''
    },
    {
      key: 'tel',
      label: '单位电话',
      value: ''
    },
    {
      key: 'fax',
      label: '传真',
      value: ''
    },
    {
      key: 'postCode',
      label: '邮编',
      value: ''
    }
  ]
};

// 机构的基础信息
export const orgBaseInfoFormat = {
  title: '基础信息',
  list: [
    {
      key: 'name',
      label: '单位全称',
      value: ''
    },
    {
      key: 'shortName',
      label: '单位简称',
      value: ''
    },
    {
      key: 'organizeCode',
      label: '组织机构代码',
      value: ''
    },
    {
      key: 'brandName',
      label: '品牌名称',
      value: ''
    },
    {
      key: 'areaName',
      label: '总部区域',
      value: ''
    },
    {
      key: 'orgAddr',
      label: '详细地址',
      value: ''
    },
    {
      key: 'legalPerson',
      label: '单位法人',
      value: ''
    },
    {
      key: 'contactName',
      label: '单位联系人姓名',
      value: ''
    },
    {
      key: 'contactPhoneNo',
      label: '联系人手机号',
      value: ''
    },
    {
      key: 'busiLicence',
      label: '工商执照注册号',
      value: ''
    },
    {
      key: 'kfTel',
      label: '客服电话',
      value: ''
    },
    {
      key: 'parentOrgId',
      label: '上级单位',
      value: ''
    },
    {
      key: 'busiRange',
      label: '经营范围',
      value: ''
    },
    {
      key: 'serviceContent',
      label: '服务内容',
      value: ''
    },
    {
      key: 'licence',
      label: '经营资质',
      value: ''
    }
  ]
};

// 课程分类状态
export const courseTypeStsList = [
  {
    value: 1,
    label: '启用'
  },
  {
    value: 0,
    label: '停用'
  }
];

// 课程分类状态 0:默认 11：德育 12：智育 13：体育 14：美育 15：劳育
export const quelityTypeList = [
  {
    value: '0',
    label: '默认'
  },
  {
    value: '11',
    label: '艺术'
  },
  {
    value: '12',
    label: '科技'
  },
  {
    value: '13',
    label: '体育'
  },
  {
    value: '14',
    label: '美术'
  },
  {
    value: '15',
    label: '综合实践'
  }
];

// 课程分类状态 21：早托22：午托23：晚托 24：全托
export const hostingTypeList = [
  {
    value: '0',
    label: '默认'
  },
  {
    value: '21',
    label: '早托'
  },
  {
    value: '22',
    label: '午托'
  },
  {
    value: '23',
    label: '晚托'
  },
  {
    value: '24',
    label: '晚修'
  }
];

// 课程类别
export const courseClassList = [
  {
    label: '全部课程类别',
    value: '0'
  },
  {
    label: '素质课',
    value: '1'
  },
  {
    label: '基础托管',
    value: '2'
  }
];

// 班级状态
export const classroomStatusList = [
  {
    label: '待上课',
    value: '1'
  },
  {
    label: '上课中',
    value: '2'
  },
  {
    label: '已完课',
    value: '3'
  },
  {
    label: '已停课',
    value: '4'
  }
];
// 新的paytype枚举
export const newPayTypeEnum = [
  '-',
  '微信支付',
  '(平安)微信支付',
  '延后支付',
  '线下支付'
];

/**
 * 考勤签到状态列表
 * 0未开始1未考勤2签到3签退4请假5缺席6停课
 * 未签到：未开始/未签到/缺勤
 * 已签到：已签到
 * 请假：请假
 * 已签退：已签退
 * 已停课的考勤记录不显示
 */

export const signStatusList = [
  {
    value: 0,
    label: '未签到'
  },
  {
    value: 1,
    label: '未签到'
  },
  {
    value: 2,
    label: '已签到'
  },
  {
    value: 3,
    label: '已签退'
  },
  {
    value: 4,
    label: '已请假'
  },
  {
    value: 5,
    label: '缺勤'
  },
  {
    value: 6,
    label: '未签到'
  },
  {
    value: 7,
    label: '考勤不在本班'
  }
];

// 班级状态 ，1：未开课 2：上课中 3：已完课 4：已停课
export const classroomSubStateList = [
  {
    label: '未开课',
    value: '1'
  },
  {
    label: '上课中',
    value: '2'
  },
  {
    label: '已完课',
    value: '3'
  },
  {
    label: '已停课',
    value: '4'
  }
];

// 课程级别
export const courseLevelStrList = ['-', '基础班', '提高班', '精英班', '其他'];

// 请假类型的枚举 leaveType
export const leaveTypeEnumList = [
  {
    label: '病假',
    value: '1'
  },
  {
    label: '事假',
    value: '2'
  },
  {
    label: '其他',
    value: '3'
  }
];

// 请假状态枚举 leaveState
export const leaveStateEnumList = [
  {
    label: '审批中',
    value: '0'
  },
  {
    label: '已通过',
    value: '1'
  },
  {
    label: '已驳回',
    value: '2'
  },
  {
    label: '已撤销',
    value: '3'
  }
];

// 退款状态枚举 refundSts
export const refundStsEnumList = [
  {
    label: '未退款',
    value: '0'
  },
  {
    label: '已退款',
    value: '1'
  },
  {
    label: '退款中',
    value: '2'
  }
];

// 是否可退款枚举 refundSts
export const isRetMoneyEnumList = [
  {
    label: '是',
    value: '1'
  },
  {
    label: '否',
    value: '0'
  }
];

// 入班状态 studentSts 0-已离班 1-已入班
export const studentStsEnumList = [
  {
    label: '已离班',
    value: '0'
  },
  {
    label: '已入班',
    value: '1'
  }
];

// 课班详情状态 1未开课2已开课3已结课
export const courseDetailStsEnumList = [
  {
    label: '未开课',
    value: 1
  },
  {
    label: '已开课',
    value: 2
  },
  {
    label: '已结课',
    value: 3
  }
];

export function arrToObj(paramsArr, key = 'value') {
  const obj = {};
  paramsArr.forEach((item) => {
    obj[item[key]] = item;
  });
  return obj;
}

/**
 * 考勤签到状态列表
 * 结算状态 0-待结算 1-已结算 2-可结算  5-已退款 6退款失败 7退款处理中  8-请假可退款  34-待结算
 */

export const tallyStsList = [
  {
    value: 0,
    label: '待结算'
  },
  {
    value: 1,
    label: '已结算'
  },
  {
    value: 2,
    label: '可结算'
  },
  {
    value: 3,
    label: '待结算'
  },
  {
    value: 4,
    label: '待结算'
  },
  {
    value: 5,
    label: '已退款'
  },
  {
    value: 6,
    label: '已退款'
  },
  {
    value: 7,
    label: '已退款'
  },
  {
    value: 8,
    label: '请假可退款'
  }
];

/**
 * 参与平台发放教师工资
 */
export const sendSalaryList = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 1,
    label: '是'
  },
  {
    value: 0,
    label: '否'
  }
];

// 退款状态 11：已退款 12：退款处理中 13：退款失败
export const refundStsList = [
  {
    value: 11,
    label: '已退款'
  },
  {
    value: 12,
    label: '退款处理中'
  },
  {
    value: 13,
    label: '退款失败'
  }
]; // 退款状态列表
// 退款审核状态 1: 退款待审核 2: 退款审批通过 3: 退款驳回 4: 已撤销
export const refundCheckStsList = [
  {
    value: 1,
    label: '退款待审批'
  },
  {
    value: 2,
    label: '退款已审批'
  },
  {
    value: 3,
    label: '退款驳回'
  },
  {
    value: 4,
    label: '已撤销'
  }
]; // 退款审批状态

export const regionDataList = [
  ...regionData,
  {
    label: '系统自定省',
    value: '990000',
    isProvince: true,
    children: [
      {
        label: '系统自定市',
        value: '990100',
        children: [
          { label: '圣比德教育', value: '990101' },
          { label: '广东省教育厅', value: '990102' }
        ]
      }
    ]
  }
];

export const leaveApplicationChannelList = [
  '-',
  '管理后台发起',
  '教师端发起',
  '家长端发起',
  '请假系统批量导入'
]; // 请假单申请渠道 1:管理后台发起 2:教师端发起 3:家长端发起 4:请假系统批量导入

// 属于已退款的结算状态  tallySts 5：已退款 6：退款失败 7：退款处理中
export const hasRefundTallyStsList = [5, 6, 7];
